/* ============================================================
   La Nani — legătura cu formularul EasySell

   Butoanele injectate de EasySell sunt ascunse din CSS. Aici doar
   le folosim ca declanșatoare, din butoanele noastre:

     „Comandă acum"      → formularul pentru produsul curent
     „Finalizați comanda" (din coș) → formularul cu tot coșul

     „Adaugă în coș" rămâne neatins.

   Totul e defensiv: dacă aplicația nu e încărcată, butoanele își
   fac treaba normală (submit către coș / checkout).
   ============================================================ */
(function () {
  'use strict';

  /* Clasele butoanelor injectate de EasySell, citite din sursa lor:
       window.ESPBPS = "es-popup-button-product"   pagina de produs
       window.ESPBCS = "es-popup-button-cart"      pagina /cart
       window.ESPBDS = "es-popup-button-drawer"    sertarul de coș

     Varianta veche căuta pentru coș doar „-drawer". Pe /cart EasySell
     injectează „-cart", deci nu găseam nimic. Măsurat pe live, pe /cart:
     ES_IS_CART_PAGE = true, două butoane „-cart", zero „-drawer". Omul
     apăsa, șase secunde nu se întâmpla nimic, apoi ajungea în checkout-ul
     standard Shopify — cu cardul, fără formular de ramburs.

     Acum, pentru coș luăm ORICE buton EasySell care nu e cel de produs.
     Așa prinde și „-cart", și „-drawer", și orice variantă viitoare. */
  var PRODUS = '.es-popup-button-product';
  var COS = '.es-popup-button:not(.es-popup-button-product)';

  /* Cât așteptăm. Măsurat pe live: butonul EasySell apare la ~525-571 ms de
     la începutul paginii. Două secunde acoperă și conexiunile lente.
     Înainte erau 40 × 150 ms = 6,15 secunde de ecran mort — adică o comandă
     pierdută, indiferent ce urma după. */
  var PAS = 100;
  var RABDARE = 2000;   /* cât așteptăm butonul */
  var RAGAZ = 500;      /* cât mai așteptăm conținutul, după ce butonul e acolo */

  /* Cât așteptăm coșul înainte să trimitem evenimentul oricum.
     Măsurat: /cart.js răspunde în ~180 ms. */
  var PRAG_COS = 600;

  /* Butonul poate fi în mai multe locuri (bara sticky, sertar, coș). Îl luăm
     pe primul din afara modalului. querySelector simplu întorcea null dacă
     primul găsit se întâmpla să fie chiar cel din modal. */
  function gaseste(sel) {
    var lista = document.querySelectorAll(sel);
    for (var i = 0; i < lista.length; i++) {
      if (!lista[i].closest('#easysell-modal')) return lista[i];
    }
    return null;
  }

  /* Semnal REAL că formularul e pus în modal.

     Varianta veche verifica `window.easysellApp && ES_INIT_FORM`, iar
     comentariul de acolo susținea că ES_INIT_FORM apare „abia după ce
     aplicația e gata". E FALS. Din sursa lor:
       created: function(){ … this.initForm(), window.ES_INIT_FORM = this.initForm }
       window.easysellApp = new Vue({…}).$mount("#tyslo")
     `created` rulează ÎNAINTE de randare, iar ambele sunt puse în același
     tick sincron. Garda aceea era adevărată din prima clipă și nu apăra de
     nimic.

     Ce e cu adevărat un semnal: EasySell mută `#easysell` în
     `.es-modal-content` (funcția lor `tt()`) chiar înainte să injecteze
     butonul, iar butonul de trimitere `.es-cta-group` e ultimul randat.
     Deci prezența butonului implică deja formularul mutat — verificarea de
     mai jos rareori mai are ce aștepta, dar când are, e reală. */
  function formularEGata() {
    var m = document.querySelector('#easysell-modal .es-modal-content');
    return !!(m && m.querySelector('.es-cta-group'));
  }

  /* Așteaptă butonul, apoi (scurt) conținutul, apoi apasă.
     Dacă butonul nu apare deloc, cheamă rezerva. */
  function deschide(sel, laEsec) {
    var trecut = 0;
    var asteptatContinut = 0;

    function pas() {
      var e = gaseste(sel);
      if (e) {
        if (formularEGata() || asteptatContinut >= RAGAZ) {
          e.click();
          /* Am apăsat. De aici încolo veghem: dacă se deschide stratul gri și
             formularul nu apare în el, îl reparăm, iar dacă nici așa nu se
             poate, închidem stratul și mergem pe rezervă. */
          vegheaza(laEsec);
          return true;
        }
        asteptatContinut += PAS;
        return false;
      }
      /* Dacă aplicația lor nici măcar nu e pe pagină, n-are rost să
         așteptăm un buton pe care nu-l injectează nimeni. */
      if (trecut >= RABDARE || (trecut >= 600 && !window.easysellApp)) {
        if (laEsec) laEsec();
        return true;
      }
      trecut += PAS;
      return false;
    }

    if (pas()) return;
    var t = setInterval(function () { if (pas()) clearInterval(t); }, PAS);
  }

  /* ============================================================
     PAZNICUL ECRANULUI GRI

     Simptom, din înregistrările Clarity, la majoritatea oamenilor: apasă
     „Comandă acum", ecranul se întunecă și se încețoșează, formularul nu
     apare, omul pleacă de pe site.

     Cauza, REPRODUSĂ pe live. Modalul lor `#easysell-modal` e doar un strat
     gol. Din foaia lor de stil:
       .es-modal{ display:none; position:fixed; width:100%; height:100%;
                  background-color:#0006; backdrop-filter:blur(3px) }
     Formularul propriu-zis e `#easysell` — un element SEPARAT, ascuns, pe
     care EasySell îl MUTĂ în `.es-modal-content` cu funcția lor `tt()`,
     apelată doar din `enablePopupForm()`. Deschiderea (`Be()`) pune numai
     display:block pe strat, atât.

     Deci dacă stratul se deschide fără ca `#easysell` să fie înăuntru și
     vizibil, iese exact ecranul raportat. Verificat: am scos `#easysell` din
     modal, l-am ascuns, am deschis stratul — captura a ieșit identică cu cea
     din înregistrări. Apoi am pus formularul înapoi și l-am făcut vizibil —
     formularul a apărut întreg.

     De ce nu rulează `tt()` la unii oameni nu am putut reproduce natural.
     Dar nu contează: reparăm starea finală, cea care se vede. Facem noi ce
     face `tt()`. Dacă nici așa nu apare nimic, ÎNCHIDEM stratul — mai bine
     îl trimitem pe drumul obișnuit decât să-l lăsăm pe un ecran mort.
     ============================================================ */
  /* PATRU straturi, nu unul. Prima versiune a paznicului păzea doar
     `#easysell-modal` — ușa greșită. Măsurat pe live, pagina are patru
     elemente cu exact aceeași înfățișare, toate `rgba(0,0,0,.4)` +
     `blur(3px)` + `z-index:2147483647`:

       #easysell-modal        formularul de comandă
       #es-upsell-modal       oferta dinainte de comandă
       #es-otp                verificarea numărului de telefon
       #es-downsell           oferta de la închidere
       #es-not-eligible-modal comanda respinsă

     Deschise goale arată IDENTIC. Iar ele se deschid înainte să aibă
     conținut. Din sursa lor, pentru OTP:
       SET_OTP_DATA(t,e){ … getElementById("es-otp").style.display = e?"block":"none" }
     adică stratul apare imediat ce vine răspunsul, iar conținutul e randat
     de Vue după. La fel `checkAndShowPrePurchaseUpsell`, care deschide
     stratul de upsell și abia apoi așteaptă rețeaua.

     Deci păzim toate ușile, nu una. */
  var STRATURI = '.es-modal, #easysell-modal, #es-upsell-modal, #es-otp, #es-downsell, #es-not-eligible-modal';
  var MODAL = '#easysell-modal';
  var VERIFICA_LA = 250;
  var RENUNTA_LA = 4000;

  function vizibil(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity) !== 0;
  }

  function modalDeschis() { return vizibil(document.querySelector(MODAL)); }

  /* Un strat e mort dacă e deschis dar nu se vede NIMIC în el.
     Prima versiune se uita doar la înălțimea copiilor direcți. Nu ajunge:
     un element poate avea înălțime și să fie totuși invizibil
     (`visibility:hidden`, `opacity:0`). Acum verificăm și asta. */
  function nimicVizibilIn(el) {
    if (!el) return false;
    var copii = el.querySelectorAll('*');
    for (var i = 0; i < copii.length; i++) {
      var r = copii[i].getBoundingClientRect();
      if (r.height <= 40 || r.width <= 40) continue;
      if (!vizibil(copii[i])) continue;
      return false;
    }
    return true;
  }

  /* pentru înregistrările Clarity: de ce era mort */
  function stareaFormularului() {
    var es = document.getElementById('easysell');
    var mc = document.querySelector('#easysell-modal .es-modal-content');
    if (!mc) return 'fara-es-modal-content';
    if (!es) return 'fara-easysell';
    if (!mc.contains(es)) return 'formular-in-afara-modalului';
    if (getComputedStyle(es).display === 'none') return 'formular-ascuns';
    if (!mc.querySelector('.es-cta-group')) return 'formular-nerandat';
    return 'inaltime-zero';
  }

  function noteazaInClarity(cheie, valoare) {
    try { if (typeof window.clarity === 'function') window.clarity('set', cheie, valoare); } catch (e) {}
  }

  /* Exact ce face `tt()` al lor, plus o cerere de reconstrucție dacă
     formularul e acolo dar gol. */
  function repara(amCerutReconstructie) {
    var es = document.getElementById('easysell');
    var mc = document.querySelector('#easysell-modal .es-modal-content');
    if (!es || !mc) return false;
    try {
      es.style.display = 'block';
      if (!mc.contains(es)) mc.appendChild(es);
    } catch (e) { return false; }
    if (!amCerutReconstructie && !mc.querySelector('.es-cta-group')) {
      try { if (typeof window.ES_ENABLE_FORM === 'function') window.ES_ENABLE_FORM(); } catch (e) {}
      return 'cerut';
    }
    return true;
  }

  /* Închiderea, la fel ca funcția lor `M()`: stratul dispare și scrollul
     paginii se pune la loc din `dataset.esPrevOverflow`, pe care ei îl
     salvează când deschid. Fără asta, pagina rămâne blocată sub un strat
     invizibil și omul crede că i s-a stricat telefonul. */
  function inchideStratul(el) {
    if (el) el.style.display = 'none';
    /* scrollul se pune la loc doar dacă nu mai e niciun strat deschis */
    var l = document.querySelectorAll(STRATURI);
    for (var i = 0; i < l.length; i++) if (vizibil(l[i])) return;
    var hb = document.querySelectorAll('html, body');
    for (var j = 0; j < hb.length; j++) {
      hb[j].style.overflow = hb[j].dataset.esPrevOverflow || '';
      delete hb[j].dataset.esPrevOverflow;
    }
  }

  /* Un singur rond care se uită la toate straturile. Ține minte de când e
     gol fiecare, ca să nu le închidă pe cele care doar întârzie. */
  var urmarite = {};
  var rond = 0;
  var rezervaInAsteptare = null;

  function faRondul() {
    var l = document.querySelectorAll(STRATURI);
    var cevaDeschis = false;

    for (var i = 0; i < l.length; i++) {
      var el = l[i];
      var id = el.id || 'fara-id';

      if (!vizibil(el)) { delete urmarite[id]; continue; }
      cevaDeschis = true;

      if (!nimicVizibilIn(el)) {
        if (urmarite[id]) {
          noteazaInClarity('ln_strat', 'reparat:' + id + ':' + urmarite[id].cauza);
          delete urmarite[id];
        }
        continue;
      }

      if (!urmarite[id]) {
        urmarite[id] = {
          de_cand: Date.now(),
          cauza: id === 'easysell-modal' ? stareaFormularului() : 'strat-gol',
          cerut: false
        };
      }

      /* Doar formularul se poate repara: îi punem noi conținutul la loc.
         Celelalte straturi n-au ce conține dacă aplicația lor n-a randat
         nimic — pe alea le închidem, ca omul să se întoarcă la pagină. */
      if (id === 'easysell-modal') {
        if (repara(urmarite[id].cerut) === 'cerut') urmarite[id].cerut = true;
      }

      if (Date.now() - urmarite[id].de_cand >= RENUNTA_LA) {
        noteazaInClarity('ln_strat', 'mort:' + id + ':' + urmarite[id].cauza);
        var eraFormularul = (id === 'easysell-modal');
        delete urmarite[id];
        inchideStratul(el);
        if (eraFormularul && rezervaInAsteptare) {
          var f = rezervaInAsteptare;
          rezervaInAsteptare = null;
          f();
        }
      }
    }

    if (!cevaDeschis && rond) { clearInterval(rond); rond = 0; }
  }

  function vegheaza(laEsecFinal) {
    if (laEsecFinal) rezervaInAsteptare = laEsecFinal;
    if (rond) return;
    rond = setInterval(faRondul, VERIFICA_LA);
  }

  /* Paznicul merge și pentru deschiderile pe care nu le pornim noi: bara lor
     sticky, butoanele lor din coș, `?easysell=1`, verificarea de telefon,
     ofertele. Ascultăm fiecare strat în parte — toate se deschid schimbând
     `style.display`. */
  (function () {
    if (!('MutationObserver' in window)) return;
    /* Un singur observator, refolosit. `observe` pe același element de două
       ori nu strică nimic, dar ținem oricum evidența, ca să nu facem muncă
       degeaba la fiecare rundă. */
    var observator = new MutationObserver(function () { vegheaza(null); });
    var legate = [];
    function leaga(incercari) {
      var l = document.querySelectorAll(STRATURI);
      for (var i = 0; i < l.length; i++) {
        if (legate.indexOf(l[i]) >= 0) continue;
        legate.push(l[i]);
        observator.observe(l[i], { attributes: true, attributeFilter: ['style', 'class'] });
        if (vizibil(l[i])) vegheaza(null);
      }
      /* straturile lor sunt create de Vue, deci pot apărea mai târziu;
         ne uităm după ele în primele ~30 de secunde din viața paginii */
      if (incercari < 30) setTimeout(function () { leaga(incercari + 1); }, 1000);
    }
    leaga(0);
  })();

  /* ============================================================
     InitiateCheckout pleacă atunci când formularul CHIAR SE DESCHIDE

     Decizia proprietarului, și e corectă: evenimentul trebuie să fie un
     semnal de sănătate pentru formular. Dacă oamenii apasă butonul și
     checkout-urile nu mai vin în Meta, se vede imediat că formularul nu se
     mai deschide. Dacă evenimentul pleacă la apăsare, semnalul ăsta se
     pierde — apar checkout-uri și când formularul n-a apărut niciodată.

     Deci: coșul îl citim la apăsare (atunci e proaspăt și rapid), dar
     evenimentul îl ținem și îl trimitem în clipa în care formularul e
     vizibil pe ecran. Dacă formularul nu se deschide deloc, evenimentul
     NU pleacă — exact ăsta e semnalul.

     Formatul, valoarea și înăbușirea dublurii de la EasySell rămân ale
     noastre, ca până acum. */
  var LIMITA_CHECKOUT = 20000;
  var checkoutInAsteptare = null;
  var ceasCheckout = 0;

  function formularVizibil() {
    var m = document.querySelector(MODAL);
    return vizibil(m) && !nimicVizibilIn(m);
  }

  function trimiteCandSeDeschide(trimite) {
    checkoutInAsteptare = { trimite: trimite, cand: Date.now() };
    if (ceasCheckout) return;
    ceasCheckout = setInterval(function () {
      if (!checkoutInAsteptare) { clearInterval(ceasCheckout); ceasCheckout = 0; return; }
      if (formularVizibil()) {
        var f = checkoutInAsteptare.trimite;
        checkoutInAsteptare = null;
        clearInterval(ceasCheckout); ceasCheckout = 0;
        f();
        return;
      }
      /* formularul nu s-a deschis: nu trimitem nimic, si asta se vede */
      if (Date.now() - checkoutInAsteptare.cand > LIMITA_CHECKOUT) {
        checkoutInAsteptare = null;
        clearInterval(ceasCheckout); ceasCheckout = 0;
      }
    }, 150);
  }

  /* Citește coșul, dar nu ține evenimentul ostatic.
     Dacă /cart.js întârzie peste PRAG_COS, mergem mai departe cu ce știm
     sigur. Mai bine o valoare incompletă decât niciun eveniment. */
  function cuCosul(gata) {
    var raspuns = false;
    var ceas;
    function o_data(c) {
      if (raspuns) return;
      raspuns = true;
      clearTimeout(ceas);
      gata(c);
    }
    ceas = setTimeout(function () { o_data(null); }, PRAG_COS);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(o_data)
      .catch(function () { o_data(null); });
  }

  document.addEventListener('click', function (ev) {
    /* --- „Comandă acum" de pe pagina produsului --- */
    var comanda = ev.target.closest && ev.target.closest('[data-ln-checkout]');

    /* Drumul nou: butonul mare doar adaugă în coș, iar formularul se
       deschide abia din fereastra care apare după. De asta îl lăsăm în
       seama lui assets/la-nani-cos.js cât timp fereastra există în pagină.

       Nu ne bazăm pe ordinea scripturilor: ambii ascultători stau pe faza
       de captură, iar `stopPropagation` nu oprește un alt ascultător pus pe
       ACELAȘI nod. Singurul lucru sigur e să ne dăm noi la o parte, aici. */
    if (comanda && document.querySelector('[data-ln-cos]')) return;

    if (comanda && !comanda.disabled) {
      ev.preventDefault();
      ev.stopPropagation();

      /* Deschiderea formularului merge prima, ca să nu aștepte după nimic
         din ce facem pentru Meta. */
      deschide(PRODUS, function () {
        /* EasySell indisponibil. Trimitem formularul normal: produsul intră
           în coș și omul ajunge pe /cart, unde EasySell mai are o șansă să
           se încarce — iar butonul de acolo chiar deschide acum formularul.
           Nu-l ducem direct în /checkout: produsul nu e încă în coș. */
        var f = comanda.closest('form');
        if (f) f.submit();
      });

      var radacina = document.querySelector('[data-ln-pdp]');
      if (radacina && window.lnMeta) {
        var idProdus = radacina.getAttribute('data-ln-varianta') ||
                       radacina.getAttribute('data-ln-handle');
        var pretProdus = parseFloat(radacina.getAttribute('data-ln-pret'));

        /* Fara butonul „Adauga in cos", AddToCart nu s-ar mai trimite
           deloc catre Meta. Il trimitem aici: produsul chiar intra in
           cos cand se deschide formularul. */
        window.lnMeta.adaugaInCos({
          handle: idProdus,
          nume: radacina.getAttribute('data-ln-nume'),
          pret: pretProdus
        });

        /* InitiateCheckout: coșul se citește AICI, la apăsare, cât e
           proaspăt și rapid — dar evenimentul pleacă abia când formularul
           se deschide pe ecran. Vezi `trimiteCandSeDeschide`.

           Valoarea trebuie să fie ce cumpără omul cu adevărat: tot coșul,
           așa cum arată el DUPĂ ce EasySell adaugă produsul curent.

           Ce face EasySell exact, din sursa lor (addVariantToCart):
             const d = getVariantQuantity(varianta);
             await updateCart({ [varianta]: d || 1 });   // POST /cart/update.js
           `/cart/update.js` SETEAZĂ cantitatea, nu o adună. Deci:
             - varianta nu e în coș  → intră cu cantitatea din pagină (aici 1)
             - varianta e deja în coș → cantitatea devine tot aia, adică
               de obicei rămâne neschimbată
           Măsurat pe live, ambele cazuri: cu produsul curent absent din coș,
           ES_TOTAL a trecut de la 599,96 la 749,95; cu produsul deja în coș,
           ES_TOTAL a rămas 449,97.

           Varianta veche trimitea doar produsul curent și îl înăbușea pe al
           EasySell, care avea valoarea corectă: 149,99 în loc de 749,95. */
        if (window.lnMeta.incepeCheckout) {
          var elVarianta = document.querySelector('[data-ln-variant-id]');
          var idVarianta = elVarianta ? elVarianta.value : null;
          var elCant = radacina.querySelector('[name="quantity"]');
          var cateBuc = elCant && parseInt(elCant.value, 10) > 0 ? parseInt(elCant.value, 10) : 1;

          cuCosul(function (c) {
            var ids = [], cant = [], valoare = 0, bucati = 0, gasit = false;
            if (c && c.items) {
              valoare = c.total_price / 100;
              bucati = c.item_count;
              c.items.forEach(function (i) {
                var esteCurenta = idVarianta
                  ? String(i.variant_id) === String(idVarianta)
                  : String(i.product_id) === String(idProdus);
                ids.push(i.variant_id);
                if (!esteCurenta) { cant.push(i.quantity); return; }
                /* varianta curentă: cantitatea ei devine cateBuc */
                gasit = true;
                var unitar = (i.final_price !== undefined ? i.final_price : i.price) / 100;
                valoare += (cateBuc - i.quantity) * unitar;
                bucati += cateBuc - i.quantity;
                cant.push(cateBuc);
              });
            }
            if (!gasit) {
              ids.push(idProdus);
              cant.push(cateBuc);
              if (isFinite(pretProdus)) valoare += pretProdus * cateBuc;
              bucati += cateBuc;
            }

            trimiteCandSeDeschide(function () {
              window.lnMeta.incepeCheckout({
                ids: ids,
                cantitati: cant,
                valoare: valoare,
                bucati: bucati
              });
            });
          });
        }
      }
      return;
    }

    /* --- „Finalizați comanda" din coș (drawer sau pagina /cart) --- */
    var finalizare = ev.target.closest && ev.target.closest('.cart__checkout-button, [name="checkout"]');
    if (finalizare && !finalizare.disabled && !finalizare.closest('#easysell-modal')) {
      /* pe pagina de produs, butonul name="checkout" e tratat mai sus */
      if (finalizare.hasAttribute('data-ln-checkout')) return;

      ev.preventDefault();
      ev.stopPropagation();

      /* dacă am venit din fereastra de după „Adaugă în coș", o dăm la o
         parte — altfel rămâne sub formular */
      if (window.lnCos && window.lnCos.inchide) window.lnCos.inchide();

      deschide(COS, function () {
        /* EasySell chiar lipsește de pe pagină: singurul drum rămas către o
           comandă e checkout-ul standard. */
        window.location.href = '/checkout';
      });

      /* La fel ca la „Comanda acum": cosul se citeste aici, la apasare, dar
         evenimentul pleaca abia cand formularul se deschide. Daca cererea
         cade sau intarzie, EasySell il trimite oricum pe al lui — nu
         inabusim ce n-am trimis noi. */
      if (window.lnMeta && window.lnMeta.incepeCheckout) {
        cuCosul(function (c) {
          if (!c || !c.items || !c.items.length) return;
          trimiteCandSeDeschide(function () {
            window.lnMeta.incepeCheckout({
              ids: c.items.map(function (i) { return i.variant_id; }),
              cantitati: c.items.map(function (i) { return i.quantity; }),
              valoare: c.total_price / 100,
              bucati: c.item_count
            });
          });
        });
      }
    }
  }, true);
})();
